import mixpanel from "mixpanel-browser";

mixpanel.init("504a733527b3982abe9336b6a2320f71");

export default mixpanel;
